import * as DialogPrimitive from '@radix-ui/react-dialog'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'

import { useCommandMenu } from '~/components/command-menu'
import { useCmdkHotkey } from '~/components/command-menu/hooks/useCmdkHotkey'
import { ActiveViewMenu } from '~/components/command-menu/menus'
import { Dialog } from '~/components/component-library/Dialog'
import { useIsMobile } from '~/utils/devices'
import { cn } from '~/utils/tailwind-utils'

export const CommandMenuDialog = () => {
  const { activeView, setActiveView } = useCommandMenu()
  const isMobile = useIsMobile()

  // register the command menu toggle
  useCmdkHotkey()

  // Load-bearing: the wrapper Dialog below swaps to a Vaul Drawer.Root on
  // mobile, which is incompatible with the Radix children. Enabling the
  // command menu on mobile requires restructuring this component, not just
  // removing this guard.
  if (isMobile) return null

  return (
    <Dialog
      open={!!activeView}
      onOpenChange={(open) => !open && setActiveView(null)}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
          forceMount
          className="fixed inset-0 z-[9998] cursor-default backdrop-brightness-[85%] data-[state=closed]:pointer-events-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 dark:backdrop-brightness-[10%]"
        />
        <DialogPrimitive.Content
          forceMount
          aria-label="Command menu"
          className={cn(
            'left-0 right-0 z-[9999] mx-auto w-full max-w-md rounded-2xl shadow-md focus-visible:outline-0 md:fixed md:top-[30dvh] md:grid',
            '![animation-duration:80ms] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
          )}
          onPointerDownOutside={() => setActiveView(null)}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <VisuallyHidden>
            <DialogPrimitive.Title>Command menu</DialogPrimitive.Title>
            <DialogPrimitive.Description>
              Search for an action or navigate to a page.
            </DialogPrimitive.Description>
          </VisuallyHidden>
          <ActiveViewMenu activeView={activeView ?? null} />
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </Dialog>
  )
}
